import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { CircularRequestComponent } from 'src/app/front-user/services/Circulars/circular-request/circular-request.component';
import { CircularService } from 'src/app/shared/services/circular.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { StepDecision, CircularsFixedRebateOptionDecisionHistory, Circular, CircularsFixedRebateOptions, Percentages, CircularOptionRebate, OptionKey, Port } from 'src/app/shared/models/circular.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { Router } from '@angular/router';
import { ErrorsEnum } from 'src/app/shared/models/enums.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { DatePipe } from '@angular/common';
import { SUConfirmTransitDecision,SUTransitApprovalDecision , Languages, ServiceStatus, FormMode } from 'src/app/shared/models/enums.model';


@Component({
  selector: 'app-cicular-requestor-rejection-notification',
  templateUrl: './cicular-requestor-rejection-notification.component.html'
})
export class CicularRequestorrejectionNotificationComponent implements OnInit {
  private RejectionNotificationForm: FormGroup;
  @ViewChild('CircularRequest',{static: false}) CircularRequest: CircularRequestComponent;
  public currentUser: User = new User();
  private CircularID;
  private RequestId: string = "";
  submitted = false;
  loading = false;
  public showRequest: boolean = false;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  isLoaded: boolean = false;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;

  public AdminDecisionDTO: StepDecision = new StepDecision();

  constructor(public datepipe: DatePipe, private formBuilder: FormBuilder, private alertService: AlertService, private lookupService: LookupService, private circularService: CircularService, private globalServices: GlobalServices, private cd: ChangeDetectorRef, private router: Router, private authenticationService: AuthenticationService) {
    this.currentUser = this.authenticationService.currentUserValue;

  }

  ngOnInit() {
    this.buildForm();
  }
  onRebateRequestLoadedFlag(flag: boolean) {

    if (flag) {
      //to hide form tiltle in circular-request compenent
      this.CircularRequest.editModeAdmin = true;
      //---------------------
      this.isLoaded = true;
      this.globalServices.IsLoaderEnabled = true;
      this.RequestId = this.CircularRequest.rebateRequestLoaded.Id;
      if (this.CircularRequest.rebateRequestLoaded.StatusId == ServiceStatus.Circulars_RejectedByRequestor){
        this.formMode = FormMode.Add;
      }
      else{
        this.formMode = FormMode.Readonly;
      }
      // this.CircularID = this.CircularRequest.rebateRequestLoaded.CircularsLookupId;
      this.RejectionNotificationForm.patchValue({
        RejectionReason: this.CircularRequest.rebateRequestLoaded.RequestorDecisionRejectionReason
      });
      this.RejectionNotificationForm.disable();
    }
  }
  buildForm(): void {
    this.RejectionNotificationForm = this.formBuilder.group({
      RejectionReason: ['']
    });

  }
  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.RejectionNotificationForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalServices.isLoaderEnabled = true;
    this.loading = true;
    this.AdminDecisionDTO.CircularFixedRebateRequestId = this.RequestId;
    this.AdminDecisionDTO.AdminEmail = this.currentUser.UserName != "" ? this.currentUser.UserName : this.currentUser.Email;

    this.circularService.rejectionNotification(this.AdminDecisionDTO)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalServices.isLoaderEnabled = false;
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalServices.isLoaderEnabled = false;
          }
          else {
            this.globalServices.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }
}
